export const REFETCH_INTERVAL = 120000;
export const ISSUES_STALE_TIME = 5 * 60 * 1000;
export const ISSUES_CACHE_TIME = 10 * 60 * 1000;
